import { CheckIcon } from 'lucide-react'

import { cn } from '@/utils'

const STEPS = ['Add documents', 'Screen the case', 'Review results']

export const ScreeningSteps = ({ currentStep }: { currentStep: number }) => (
  <ol className="flex flex-wrap items-center gap-x-2 gap-y-2 text-sm">
    {STEPS.map((label, index) => {
      const step = index + 1
      const isDone = step < currentStep
      const isCurrent = step === currentStep

      return (
        <li key={label} className="flex items-center gap-2">
          {index > 0 && <span aria-hidden className="h-px w-6 bg-border" />}
          <span
            aria-current={isCurrent ? 'step' : undefined}
            className={cn(
              'flex items-center gap-2 rounded-full border px-3 py-1',
              isCurrent && 'border-brand/40 bg-brand/5 font-medium',
              !isCurrent && 'border-transparent text-muted-foreground',
            )}
          >
            <span
              className={cn(
                'flex h-4.5 w-4.5 items-center justify-center rounded-full text-[10px] font-semibold',
                isDone && 'bg-emerald-100 text-emerald-700',
                isCurrent && 'bg-brand text-white',
                !isDone && !isCurrent && 'bg-muted text-muted-foreground',
              )}
            >
              {isDone ? (
                <CheckIcon className="h-2.5 w-2.5" strokeWidth={3} />
              ) : (
                step
              )}
            </span>
            {label}
          </span>
        </li>
      )
    })}
  </ol>
)
